import Vue from 'vue'
import Router from 'vue-router'
import login from '@/views/user/login'
import register from '@/views/user/register'
import index from '../views/index'
import message from '../views/message'
import my from '../views/user/my'
import userInfo from '../views/user/info'
import WarrantyDetail from '../views/order/detail'
import WarrantyList from '../views/order/list'
import WarrantyReport from '../views/order/report'
import orderCreate from '../views/order/create'
import orderCalendar from '../views/order/calendar'
import orderReimbursement from '../views/order/reimbursement'
import orderReimbursementList from '../views/order/reimbursement_list'
import orderReimbursementCheckList from '../views/reimbursement/check_list'
import orderReimbursementCheckListPc from '../views/reimbursement/check_list_pc'
import orderReimbursementCheckDetail from '../views/reimbursement/check_detail'
import orderMobileCreateReport from '../views/order/mobile-new-create-report'
import orderPreReimbursementList from '../views/order/reimbursement_pre_list'
import workerWarrantyList from '../views/order/worker_warranty_list'
import ReimbursementPc from '../views/order/reimbursement_pc'
import WorkIdentify from '../views/user/components/identity'
import WorkCard from '../views/user/components/certificates'
import WorkHealthReport from '../views/user/components/health_report'
import WorkSign from '../views/user/sign'
import WorkNewSign from '../views/user/new_sign'
import OrderWorkers from '../views/order/components/order-workers'
import OrderSelectWorkers from '../views/order/components/create-worker'
import OrderCreateReport from '../views/order/create_report'
import ReportList from '../views/order/report_list'
import ReportListPC from '../views/order/report_list_pc'
import OrderReportList from '../views/order/order_report_list'
import WorkerPdf from '../views/order/components/worker-pdf-preview'
import ReportPdf from '../views/order/components/report-pdf-preview'
import CooperationWorkers from '../views/order/cooperation_workers'
import OrderStat from '../views/stat/stat'
import Chat from '../views/order/chat'
import Records from '../views/order/record'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: login,
      meta: {
        title: '工人端-登录'
      }
    },
    {
      path: '/register',
      name: 'register',
      component: register,
      meta: {
        title: '注册'
      }
    },
    {
      path: '/index',
      name: 'index',
      component: index,
      meta: {
        title: '首页'
      }
    },
    {
      path: '/my',
      name: 'my',
      component: my,
      meta: {
        title: '工人端-我的'
      }
    },
    {
      path: '/message',
      name: 'message',
      component: message,
      meta: {
        title: '工人端-消息中心'
      }
    },
    {
      path: '/warranty_detail',
      name: WarrantyDetail,
      component: WarrantyDetail,
      meta: {
        title: '工人端-维修单详情'
      }
    },
    {
      path: '/warranty_list',
      name: WarrantyList,
      component: WarrantyList,
      meta: {
        title: '工人端-维修单列表'
      }
    },
    {
      path: '/warranty_report',
      name: WarrantyReport,
      component: WarrantyReport,
      meta: {
        title: '工人端-完工报告'
      }
    },
    {
      path: '/user_info',
      name: userInfo,
      component: userInfo,
      meta: {
        title: '工人端-用户信息'
      }
    },
    {
      path: '/order_create',
      name: orderCreate,
      component: orderCreate,
      meta: {
        title: '工人端-订单创建'
      }
    },
    {
      path: '/order_calendar',
      name: orderCalendar,
      component: orderCalendar,
      meta: {
        title: '工人端-工程日历'
      }
    },
    {
      path: '/order_reimbursement',
      name: orderReimbursement,
      component: orderReimbursement,
      meta: {
        title: '工人端-报销单'
      }
    },
    {
      path: '/order_reimbursement_list',
      name: orderReimbursementList,
      component: orderReimbursementList,
      meta: {
        title: '工人端-报销单列表'
      }
    },
    {
      path: '/worker_warranty_list',
      name: workerWarrantyList,
      component: workerWarrantyList,
      meta: {
        title: '工人端-报销单列表'
      }
    },
    {
      path: '/warranty_pc_detail',
      name: ReimbursementPc,
      component: ReimbursementPc,
      meta: {
        title: '工人端-维修单详情'
      }
    },
    {
      path: '/worker_identity',
      name: WorkIdentify,
      component: WorkIdentify,
      meta: {
        title: '工人身份信息'
      }
    },
    {
      path: '/worker_card',
      name: WorkCard,
      component: WorkCard,
      meta: {
        title: '工人证件信息'
      }
    },
    {
      path: '/worker_health_report',
      name: WorkHealthReport,
      component: WorkHealthReport,
      meta: {
        title: '工人健康报告信息'
      }
    },
    {
      path: '/worker_sign',
      name: WorkSign,
      component: WorkSign,
      meta: {
        title: '工人签字'
      }
    },
    {
      path: '/worker_new_sign',
      name: WorkNewSign,
      component: WorkNewSign,
      meta: {
        title: '工人签字'
      }
    },
    {
      path: '/order_worker',
      name: OrderWorkers,
      component: OrderWorkers,
      meta: {
        title: '工人列表'
      }
    },
    {
      path: '/order_select_worker',
      name: OrderSelectWorkers,
      component: OrderSelectWorkers,
      meta: {
        title: '选择工人'
      }
    },
    {
      path: '/order_create_report',
      name: OrderCreateReport,
      component: OrderCreateReport,
      meta: {
        title: '创建报告'
      }
    },
    {
      path: '/report_list',
      name: ReportList,
      component: ReportList,
      meta: {
        title: '创建报告'
      }
    },
    {
      path: '/report_list_pc',
      name: ReportListPC,
      component: ReportListPC,
      meta: {
        title: '创建报告'
      }
    },
    {
      path: '/worker_pdf',
      name: WorkerPdf,
      component: WorkerPdf,
      meta: {
        title: '施工人员信息pdf'
      }
    },
    {
      path: '/report_pdf',
      name: ReportPdf,
      component: ReportPdf,
      meta: {
        title: '报告单pdf'
      }
    },
    {
      path: '/order_report_list',
      name: OrderReportList,
      component: OrderReportList,
      meta: {
        title: '订单报告单'
      }
    },
    {
      path: '/cooperation_workers',
      name: CooperationWorkers,
      component: CooperationWorkers,
      meta: {
        title: '合作工人'
      }
    },
    {
      path: '/order_stat',
      name: OrderStat,
      component: OrderStat,
      meta: {
        title: '统计列表'
      }
    },
    {
      path: '/chat',
      name: Chat,
      component: Chat,
      meta: {
        title: '智能聊天'
      }
    },
    {
      path: '/order_reimbursement_check',
      name: orderReimbursementCheckList,
      component: orderReimbursementCheckList,
      meta: {
        title: '待审批列表'
      }
    },
    {
      path: '/order_reimbursement_check_pc',
      name: orderReimbursementCheckListPc,
      component: orderReimbursementCheckListPc,
      meta: {
        title: '待审批列表'
      }
    },
    {
      path: '/order_reimbursement_check_detail',
      name: orderReimbursementCheckDetail,
      component: orderReimbursementCheckDetail,
      meta: {
        title: '待审批详情'
      }
    },
    {
      path: '/order_mobile_create_report',
      name: orderMobileCreateReport,
      component: orderMobileCreateReport,
      meta: {
        title: '新建报告单'
      }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js